import PropTypes from 'prop-types';

export const gradesTableType = PropTypes.arrayOf(PropTypes.shape({
  number: PropTypes.string,
  answer: PropTypes.string,
  mark: PropTypes.number,
  max_mark: PropTypes.number,
}));

export default gradesTableType;
